"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxButton = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Label = require("b2b-components/theme/components/Form/Label");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _CheckboxInput = require("../CheckboxInput");
var _useCheckboxState = require("../useCheckboxState");
var _ = require("./");
require("./CheckboxButton.scss");
var CheckboxButton = function CheckboxButton(_ref) {
  var _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? _.CHECKBOX_BUTTON_ICON_NAME.compare : _ref$icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _.CHECKBOX_BUTTON_SIZE["default"] : _ref$size,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? _.CHECKBOX_BUTTON_STYLE_TYPE.primary : _ref$styleType,
    isChecked = _ref.isChecked,
    isDefaultChecked = _ref.isDefaultChecked,
    onChange = _ref.onChange,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    className = _ref.className;
  var state = (0, _useCheckboxState.useCheckboxState)(isDefaultChecked, isChecked, onChange);
  var rootClassName = (0, _classnames["default"])(className, 'cds-CheckboxButton', (0, _defineProperty2["default"])({}, "cds-CheckboxButton--".concat((0, _upperCaseFirst.upperCaseFirst)(size)), size));
  return /*#__PURE__*/_react["default"].createElement(_Label.Label, {
    className: rootClassName,
    onClick: state.onClick
  }, /*#__PURE__*/_react["default"].createElement(_CheckboxInput.CheckboxInput, {
    isChecked: state.isChecked,
    isDisabled: isDisabled,
    onChange: state.onChange
  }), /*#__PURE__*/_react["default"].createElement(_ButtonIcon.ButtonIcon, {
    icon: icon,
    styleType: styleType,
    isDisabled: isDisabled,
    size: size,
    renderDiv: true
  }), state.isChecked && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CheckboxButton-CheckIconBox"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.Icon.config.name.checkmark,
    className: "cds-CheckboxButton-CheckIcon"
  })));
};
exports.CheckboxButton = CheckboxButton;